import { render } from "./ProjectRecommendations.vue?vue&type=template&id=a99aa2be"
import script from "./ProjectRecommendations.vue?vue&type=script&lang=js"
export * from "./ProjectRecommendations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__